import axios from "axios"
import { mapState, mapMutations, mapActions } from "vuex"
import config from "../utils/config"
export default init = {
  data() {
    return {
      curentPage: 0,
      loading: false,
    }
  },
  computed: {
    ...mapState("products", [
      "breadcrumbs",
      "filterProds",
      "filters",
      "street",
      "categoryID",
    ]),
    ...mapState("map", ["isMapOpen"]),
    totalResults() {
      return window.total
    },
    description(){
      return window.description
    }
  },

  methods: {
    ...mapMutations("products", [
      "setFilters",
      "setBreadcrumbs",
      "setSelected",
      "setCategories",
      "setPageLimit",
      "setCategoryID",
    ]),
    ...mapMutations("map", ["setCord", "setRadius", "setSearchCord"]),
    ...mapActions("products", ["fillterStreet", "filterCords", "setProducts"]),
    setLoader() {
      this.loading = true
      document.documentElement.style.overflow = "hidden"
      document.body.style.overflow = "hidden"
    },
    removeLoader() {
      this.loading = false
      document.documentElement.style.overflow = "auto"
      document.body.style.overflow = "auto"
    },
    setKeys() {
      const selected = JSON.parse(localStorage.getItem("selected"))
      let data = {}
      if (selected && selected.categoryID === this.categoryID) {
        data = selected.selected
      } else {
        Object.keys(this.filters).forEach((key) => {   
          data[key] = []      
        })
      }
      return data
    },

    setCords() {
      const search = window.location.search.split("&")
      const cords = search[1] ? search[1].split(",") : []
    
      let cord = {}
      if (search[2] && search[2] !== "false") {
        const addressString = decodeURI(search[2]).split(",")
        const address = addressString[0] + "," + addressString[1]
        this.fillterStreet(address)
        this.setRadius(window.addressRadius)
      } else {
        this.setRadius(window.radius)
      }
      if (cords[0] && cords[1]) {
        cord = { lat: +cords[0], lng: +cords[1] }
        this.setSearchCord(cord)
        this.filterCords()
      } else {
        cord = window.cord
      }
      this.setCord(cord)
    },
    async getProducts() {
      const configs = config
      configs.headers["NETOAPI_ACTION"] = "GetItem"
      const resProd = await axios.post(
        "https://www.skyepics.com.au/do/WS/NetoAPI",
        {
          Filter: {
            CategoryID: this.categoryID,
            Limit: 400,
            IsActive:["true"],
            Approved:["true"],
            Page: this.curentPage,
            OrderBy: "DateAdded",
            OrderDirection: "DESC",
            OutputSelector: [
              "DateAdded",
              "ItemURL",
              "Images",
              "Misc02",
              "Misc46",
              "Misc03",
              "Misc45",
              "Misc51",
              "Name",
              "ID",
              "Misc13",
              "ItemSpecifics"             
            ],
          },
        },
        configs
      )
      const prods = resProd.data
      if (
        this.totalResults > this.filterProds.length &&
        prods.Item.length > 0
      ) {
        this.curentPage++
        this.setProducts(this.mapProducts(prods.Item))
        this.removeLoader()
        return this.getProducts()
      }
      this.removeLoader()
    },
    mapProducts(items) {
      const prods = []
      items.forEach((item) => {
        const filters = {}      
        if (item.ItemSpecifics[0] &&  item.ItemSpecifics[0].ItemSpecific.length > 0) {
          item.ItemSpecifics[0].ItemSpecific.forEach((item) => {
            filters[item.Name] = item.Value
          })
        }

        prods.push({
          date: item.DateAdded,
          href: "/" + item.ItemURL,
          img: item.Images[0]?.ThumbURL,
          imgFull: item.Images[0]?.URL,
          lat: item.Misc02,
          lng: item.Misc03,
          name: item.Name,
          sku: item.Misc46,
          video: item.Misc13,
          historical: item.Misc51,
          filters: filters,
          premium:  item.Misc45
        })
      })
      return prods
    },
    init() {
      this.setLoader()
      this.setCategoryID(window.categoryId)
      this.setFilters(window.filters)
      this.setCategories(window.categories)
      this.setCords()
      this.setSelected(this.setKeys())
      this.setBreadcrumbs(window.breadcrumbs)   
      this.getProducts()
    },
  },
}
